


















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { SmartQuery } from 'vue-apollo-decorator';
import { CURRENT_UNIT } from '@/queries/Application';
import { GQL_currentUnit_currentUnit } from '@/queries/__generated__/currentUnit';
import YearSelect from '../YearSelect.vue';
import BookkeptTable from './BookkeptTable.vue';
import PaycheckSummaryTable from './PaycheckSummaryTable.vue';
import DiffTable from './DiffTable.vue';
import PaychecksNotInYearPaidInYear from './PaychecksNotInYearPaidInYear.vue';
import PaychecksInYearNotPaidInYear from './PaychecksInYearNotPaidInYear.vue';
import {
  GQL_paychecksAndBookkeepingReconciliationReport, GQL_paychecksAndBookkeepingReconciliationReport_paychecksAndBookkeepingReconciliationReport_bookkeptTable,
  GQL_paychecksAndBookkeepingReconciliationReport_paychecksAndBookkeepingReconciliationReport_columnHeaders,
  GQL_paychecksAndBookkeepingReconciliationReport_paychecksAndBookkeepingReconciliationReport_diffTable,
  GQL_paychecksAndBookkeepingReconciliationReport_paychecksAndBookkeepingReconciliationReport_paycheckSummaryTable,
  GQL_paychecksAndBookkeepingReconciliationReport_paychecksAndBookkeepingReconciliationReport_paychecksNotInYearPaidInYear,
  GQL_paychecksAndBookkeepingReconciliationReport_paychecksAndBookkeepingReconciliationReport_paychecksInYearNotPaidInYear,
} from '@/queries/__generated__/paychecksAndBookkeepingReconciliationReport';
import gql from 'graphql-tag';

const PAYCHECKS_AND_BOOKKEEPING_RECONCILIATION_REPORT = gql`
  query paychecksAndBookkeepingReconciliationReport($unitId: ID!, $year: Int!) {
    paychecksAndBookkeepingReconciliationReport(unitId: $unitId, year: $year) {

      columnHeaders {
        description
      }

      paycheckSummaryTable {
        rows {
          workRelation {
            id
            employmentPercentage
            employmentType
            occupation {
              id
              name
            }
            employee {
              id
              firstName
              lastName
            }
          }
          vacationMoneyBaseUnpaid
          columns
        }
        footer {
          vacationMoneyBaseUnpaid
          columns
        }
      }

      bookkeptTable {
        rows {
          bookkeepingAccountName
          bookkeepingAccountNumber
          vacationMoneyBaseUnpaid
          columns
        }
        footer {
          vacationMoneyBaseUnpaid
          columns
        }
      }

      diffTable {
        paycheckSummaryTableSums {
          vacationMoneyBaseUnpaid
          columns
        }
        paychecksNotInYearPaidInYearSums {
          vacationMoneyBaseUnpaid
          columns
        }
        paychecksInYearNotPaidInYearSums {
          vacationMoneyBaseUnpaid
          columns
        }
        bookkeptTableSums {
          vacationMoneyBaseUnpaid
          columns
        }
        diff {
          vacationMoneyBaseUnpaid
          columns
        }
      }

      paychecksNotInYearPaidInYear {
        rows {
          paycheck {
            id
            number
            workRelation {
              id
              employmentPercentage
              employmentType
              occupation {
                id
                name
              }
              employee {
                id
                firstName
                lastName
              }
            }
          }
          vacationMoneyBaseUnpaid
          columns
        }
        footer {
          vacationMoneyBaseUnpaid
          columns
        }
      }

      paychecksInYearNotPaidInYear {
        rows {
          paycheck {
            id
            number
            workRelation {
              id
              employmentPercentage
              employmentType
              occupation {
                id
                name
              }
              employee {
                id
                firstName
                lastName
              }
            }
          }
          vacationMoneyBaseUnpaid
          columns
        }
        footer {
          vacationMoneyBaseUnpaid
          columns
        }
      }

    }
  }
`;

@Component({
  components: {
    YearSelect,
    BookkeptTable,
    PaycheckSummaryTable,
    DiffTable,
    PaychecksNotInYearPaidInYear,
    PaychecksInYearNotPaidInYear,
  },
})
export default class PaychecksAndBookkeepingReconciliationReport extends Vue {
  @Prop({ type: Number, required: true }) private year!: number;

  @SmartQuery({
    query: CURRENT_UNIT,
    result() { this.getReport() },
  }) private currentUnit!: GQL_currentUnit_currentUnit;

  private loading = true;

  private report: {
    headers: GQL_paychecksAndBookkeepingReconciliationReport_paychecksAndBookkeepingReconciliationReport_columnHeaders[];
    bookkeptTable: GQL_paychecksAndBookkeepingReconciliationReport_paychecksAndBookkeepingReconciliationReport_bookkeptTable;
    paycheckSummaryTable: GQL_paychecksAndBookkeepingReconciliationReport_paychecksAndBookkeepingReconciliationReport_paycheckSummaryTable;
    diffTable: GQL_paychecksAndBookkeepingReconciliationReport_paychecksAndBookkeepingReconciliationReport_diffTable;
    paychecksNotInYearPaidInYear: GQL_paychecksAndBookkeepingReconciliationReport_paychecksAndBookkeepingReconciliationReport_paychecksNotInYearPaidInYear;
    paychecksInYearNotPaidInYear: GQL_paychecksAndBookkeepingReconciliationReport_paychecksAndBookkeepingReconciliationReport_paychecksInYearNotPaidInYear;
  } | null = null;

  @Watch('year')
  private getReport() {
    this.loading = true;

    this.$apollo.query({
      query: PAYCHECKS_AND_BOOKKEEPING_RECONCILIATION_REPORT,
      fetchPolicy: 'no-cache',
      variables: {
        year: this.year,
        unitId: this.currentUnit.id,
      },
    }).then((data: {data: GQL_paychecksAndBookkeepingReconciliationReport}) => {
      const report = data.data.paychecksAndBookkeepingReconciliationReport;
      if (!report) return;

      this.report = {
        headers: report.columnHeaders,
        bookkeptTable: report.bookkeptTable,
        paycheckSummaryTable: report.paycheckSummaryTable,
        diffTable: report.diffTable,
        paychecksNotInYearPaidInYear: report.paychecksNotInYearPaidInYear,
        paychecksInYearNotPaidInYear: report.paychecksInYearNotPaidInYear,
      };
    })
    .catch(() => this.report = null)
    .finally(() => this.loading = false);
  }
}
